/**
 * The URL alone must fully bootstrap the kiosk (touchscreen-frontend.md §Kiosk). Everything the
 * app needs at cold boot comes from the venue reference and optional dev query params — nothing
 * from `localStorage` is required to reach a working screen.
 */
export interface BootParams {
  venueRef: string | null;
  devKey: string | null;
}

export function readBootParams(search: string, pathname: string): BootParams {
  const params = new URLSearchParams(search);
  const pathMatch = pathname.match(/^\/(JUKE[0-9]+)\/?$/i);
  return {
    venueRef: params.get("venue") || pathMatch?.[1] || null,
    devKey: params.get("dev"),
  };
}
